<template>
<div class="wrap">
	<b-alert show variant="success">
    Идет загрузка данных. Пожалуйста подождите <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
  </b-alert>
</div>
	
</template>

<script>
	export default{
		data(){
			return{

			}
		}
	}
</script>

<style scoped >
.wrap{
	width: 100%;
}
	.alert{
		margin: 20px auto;
		width: 90%;
	}
</style>
